import script from "./ProjectDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDataTable.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDataTable.vue?vue&type=style&index=0&id=d05e7eb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d05e7eb6"]])

export default __exports__